import React from 'react';
import {Styles} from '../../../..//../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../../config/Translate";
import { withSnackbar } from 'notistack';
import withWidth from "@material-ui/core/withWidth/withWidth";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import IconButton from "@material-ui/core/IconButton/IconButton";
import EventAvailableRoundedIcon from '@material-ui/icons/EventAvailableRounded';
import RoomRoundedIcon from '@material-ui/icons/RoomRounded';
import {CalendarViewDay} from "@material-ui/icons";
import CloseIcon from "@material-ui/icons/Close";
import ListItem from "@material-ui/core/ListItem/ListItem";
import List from "@material-ui/core/List/List";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction/ListItemSecondaryAction";
import Checkbox from "@material-ui/core/Checkbox/Checkbox";
import moment from "jalali-moment";
class orderHistoryDialog extends React.Component {
    state = {
        open:false,
    };
    handleDone(){
        this.setState({
            open:false,
        })
        this.props.reload();
    }
    render(){
        let {open} = this.state;
        let {histories} = this.props;
        return(
            <>
                <IconButton
                    color="primary"
                    onClick={() => this.setState({open: !this.state.open})}
                >
                    <EventAvailableRoundedIcon/>
                </IconButton>
                <Dialog  fullWidth maxWidth="sm"  open={open} onClose={() => this.setState({open: !this.state.open})} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">
                        <IconButton>
                            <EventAvailableRoundedIcon color="primary"/>
                        </IconButton>
                        {Translate.orderHistory}
                        <IconButton aria-label="close" className="modal-close-btn"  onClick={() => this.setState({open: !this.state.open})}>
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <List>
                            {
                                histories.map((history,index) => (
                                    <ListItem key={index}>
                                        <ListItemText primary={Translate[history.status]} />
                                        <ListItemSecondaryAction>
                                            <span>{`${moment(history.created_at).locale('fa').format( 'YYYY/M/D H:mm')}`}</span>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                ))
                            }
                        </List>
                    </DialogContent>
                </Dialog>
            </>
        )
    }
}

export default withWidth()(withSnackbar(withStyles(Styles)(orderHistoryDialog)));